import { Group, Layout, Page, Tree } from "@/comn/components";
import { useNavigate } from "react-router-dom";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { TFormSchema, useFetch, useForm, useModal, useResource, useToast, usePage } from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import { APIS, BASE, URLS, SF_HLDY_MGMT_INFO } from "@/tra/tancis/ptli/crtr/hldy/services/PtliHldyMgmtService";

/*
 * Holiday Management Registration
 * !== 휴일 관리 등록 ==!
 */
export const PTLI0408002S = () => {
    useResource({
        defaultSchema: [{ area: "cstmCd" }, { area: "comnCd", comnCd: "COM0057" }],
    });
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0003"],
    });
    const navigate = useNavigate();
    const modal = useModal();
    const toast = useToast();
    const { t } = useTranslation();

    const form = {
        hldyMgmtInfo: useForm({
            defaultSchema: SF_HLDY_MGMT_INFO,
        }),
    };

    const fetch = {
        insertHldyMgmtInfo: useFetch({
            api: (data: any) => APIS.insertHldyMgmtInfo(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00058" }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                navigate(`${URLS.ptli0408001q}?menuId=${menuId}`);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
    };

    const handler = {
        onRestBtnClick: () => {
            handler.clearFormState();
            form.hldyMgmtInfo.reset();
        },
        onListBtnClick: () => {
            navigate(`${URLS.ptli0408001q}?menuId=${menuId}`);
        },
        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.hldyMgmtInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.hldyMgmtInfo.handleSubmit(
                () => {
                    const data = form.hldyMgmtInfo.getValues();
                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.insertHldyMgmtInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                    console.log(comnUtils.isEmpty(form.hldyMgmtInfo.errors), form.hldyMgmtInfo.isSubmitted);
                },
            )();
        },
        clearFormState: () => {
            form.hldyMgmtInfo.clearErrors();
            form.hldyMgmtInfo.resetSchema();
        },
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.hldyMgmtInfo.schema.hldyNm} />
                            <Group.Control {...form.hldyMgmtInfo.schema.ctraDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.hldyMgmtInfo.schema.hldyTpCd} />
                            <Group.Control {...form.hldyMgmtInfo.schema.cstmOfceCd} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onSaveBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
